module.exports = __webpack_public_path__ + "static/media/S (41).2a3bf08a.jpg";